import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "accessibilityLabel", "gray", "height", "id", "inverse", "testID", "UNSAFE_svgProps", "UNSAFE_pathStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Shape } from '@bubble-ui/primitive-shape';
import { Surface } from '@bubble-ui/primitive-surface';
import { useStyleSheet } from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { withProvisionalOverrideFromContext } from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var viewBoxWidth = 81;
var viewBoxHeight = 20;
var KlarnaLogoFullComponent = _ref => {
  var {
      'aria-label': ariaLabel,
      accessibilityLabel: ariaLabelDeprecated,
      gray,
      height = 20,
      id,
      inverse,
      testID,
      UNSAFE_svgProps,
      UNSAFE_pathStyle
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'KlarnaLogoFull',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  var designVersion = useDesignVersion();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    rootStyle
  } = useStyleSheet(KlarnaLogoFullComponent, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    accessibilityLabel: ariaLabel || ariaLabelDeprecated,
    designVersion,
    gray,
    id,
    inverse,
    testID,
    UNSAFE_svgProps,
    UNSAFE_pathStyle
  }));
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    "aria-label": ariaLabel || ariaLabelDeprecated,
    width: viewBoxWidth / viewBoxHeight * height,
    height: height,
    viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M73.4928 16.2723C71.6091 16.2723 70.1409 14.7147 70.1409 12.8232C70.1409 10.9318 71.6091 9.37416 73.4928 9.37416C75.3765 9.37416 76.8447 10.9318 76.8447 12.8232C76.8447 14.7147 75.3765 16.2723 73.4928 16.2723ZM72.551 19.9161C74.1577 19.9161 76.2076 19.3042 77.3434 16.9121L77.4542 16.9677C76.9556 18.275 76.9555 19.0538 76.9555 19.2485V19.5545H81V6.09197H76.9555V6.39794C76.9555 6.59265 76.9556 7.37147 77.4542 8.67878L77.3434 8.73441C76.2076 6.34231 74.1577 5.73038 72.551 5.73038C68.7004 5.73038 65.9856 8.79004 65.9856 12.8232C65.9856 16.8564 68.7004 19.9161 72.551 19.9161ZM58.9494 5.73038C57.1211 5.73038 55.6806 6.37012 54.5171 8.73441L54.4063 8.67878C54.9049 7.37147 54.9049 6.59265 54.9049 6.39794V6.09197H50.8605V19.5545H55.0157V12.4616C55.0157 10.598 56.0961 9.42979 57.8413 9.42979C59.5865 9.42979 60.4453 10.4311 60.4453 12.4338V19.5545H64.6005V10.9874C64.6005 7.92777 62.2182 5.73038 58.9494 5.73038ZM44.8492 8.73441L44.7384 8.67878C45.237 7.37147 45.237 6.59265 45.237 6.39794V6.09197H41.1925V19.5545H45.3478L45.3755 13.0736C45.3755 11.1821 46.3728 10.0417 48.0072 10.0417C48.4504 10.0417 48.8105 10.0974 49.2261 10.2086V6.09197C47.3977 5.70256 45.7633 6.39794 44.8492 8.73441ZM31.6354 16.2723C29.7517 16.2723 28.2835 14.7147 28.2835 12.8232C28.2835 10.9318 29.7517 9.37416 31.6354 9.37416C33.5192 9.37416 34.9873 10.9318 34.9873 12.8232C34.9873 14.7147 33.5192 16.2723 31.6354 16.2723ZM30.6936 19.9161C32.3003 19.9161 34.3502 19.3042 35.486 16.9121L35.5968 16.9677C35.0982 18.275 35.0982 19.0538 35.0982 19.2485V19.5545H39.1426V6.09197H35.0982V6.39794C35.0982 6.59265 35.0982 7.37147 35.5968 8.67878L35.486 8.73441C34.3502 6.34231 32.3003 5.73038 30.6936 5.73038C26.843 5.73038 24.1283 8.79004 24.1283 12.8232C24.1283 16.8564 26.843 19.9161 30.6936 19.9161ZM18.3386 19.5545H22.4938V0.0839043H18.3386V19.5545ZM15.2914 0.0839043H11.053C11.053 3.5608 8.91997 6.67609 5.67887 8.9013L4.40458 9.79139V0.0839043H0V19.5545H4.40458V9.90265L11.6902 19.5545H17.0643L10.0557 10.3199C13.2415 8.01122 15.3191 4.42306 15.2914 0.0839043Z"
  }, _objectSpread(_objectSpread({}, rootStyle), UNSAFE_pathStyle))));
};
KlarnaLogoFullComponent.displayName = 'KlarnaLogoFull';
export var KlarnaLogoFull = withProvisionalOverrideFromContext(KlarnaLogoFullComponent);
//# sourceMappingURL=index.js.map